import { jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ jsx("svg", { width: 26, height: 21, viewBox: "0 0 26 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M26 3L9 21L0 12L3 9L9 15L23 0L26 3Z", fill: "currentColor" }) });
export default SvgCheckmark;
